import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import usersService from "../services/User.Service";

    export const saveShoppingPartners = createAsyncThunk("/user/save", async (params, thunkAPI)=>{
        try{
            const data = await usersService.saveNewPartnersData(params);
            return data.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    
    });

    export const shoppingPartnersList = createAsyncThunk("/vendors/list", async ({data, type},thunkAPI)=>{
        try{
            let pageData =  Object.assign({}, data)
            
            // if(pageData.page){
            //     pageData.page = pageData.page - 1  
            // }
            const listData = await usersService.loadPatnersData(pageData, type);
            return listData.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    
    });

    export const allParentList = createAsyncThunk("/parent/all", async ({pincode, type}, thunkAPI)=>{
        try{
            const data = await usersService.loadAllDistributors({pincode, type});
            return data.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    });

    export const getPartnerById = createAsyncThunk("/partnerById", async ({id, type},thunkAPI)=>{
        try{
            const data = await usersService.getPartnerById(id, type);
            return data.data;
        }catch(exception){
            if (!exception.response) {
            return exception
            }
            return thunkAPI.rejectWithValue(exception?.response?.data)
        }
    });

    const initialState = {
        list:[],
        allParentList:[],
        totalCount:0,
        editData:{},
        errors:'',
        success:'',
        loading:false,
        message:false,
    }
    
    const shoppingPartners = createSlice({
            name : "shoppingPartners",
            initialState,
            reducers:{
                reset:(state,action) =>{
                    if(Object.keys(action.payload) > 0){
                    return {
                        ...initialState,
                        ...action.payload
                    }
                    }else{
                        return  initialState
                    }
                    
                },
                resetApiStatus:(state) => {
                    return {
                        ...initialState,
                        errors:'',
                        success:'',
                        loading:false,
                        message:''
                    }
                },
                checkGoods: ()=>{
                    console.log("Goods Check")
                },
                setEditData:(state, action)=>{
                    const data = state.list.find( (item) => {
                        return  item._id === action.payload.id
                    } )    
                }
            },
        extraReducers: {
            [saveShoppingPartners.pending] : (state) => {
                state.loading = true
                state.errors = ''
                state.success = ''
            },
            [saveShoppingPartners.fulfilled] : (state, action) => {
                state.loading = false;
                const data = action.payload
                state.success = data.msg; 
            },    
            [saveShoppingPartners.rejected] : (state, action) => {
                state.loading = false;
                state.success = false
                let vErrors = []
                vErrors = Array.isArray(action.payload.errors.msg)?[...new Map(action.payload.errors.msg.map(item => [item['param'], item])).values()].map((item)=>{
                    return `${item.param}: ${item.msg}`
                }):action.payload.errors.msg
                state.errors = vErrors;  
            },
            
            [shoppingPartnersList.pending] : (state) => {
                state.loading = true
                state.errors = false
            },
            [shoppingPartnersList.fulfilled] : (state, action) => {
                state.loading = false;
                state.success = "";
                state.totalCount = action.payload.totalDocs
                state.list = action.payload.docs;
            },    
            [shoppingPartnersList.rejected] : (state, action) => {
                state.loading = false;
                state.error = action.payload?.error?.msg;    
            },

            [allParentList.pending] : (state) => {
                state.loading = true
                state.errors = false
            },
            [allParentList.fulfilled] : (state, action) => {
                state.loading = false;
                state.success = "";
                state.allParentList = action.payload.data;
            },    
            [allParentList.rejected] : (state, action) => {
                state.loading = false;
                state.error = action.payload.error.msg;    
            },

            [getPartnerById.pending] : (state) => {
                state.loading = true
                state.errors = false
            },
            [getPartnerById.fulfilled] : (state, action) => {
                state.loading = false;
                state.success = "";
                state.editData = action.payload?.data || action.payload?.docs;
            },    
            [getPartnerById.rejected] : (state, action) => {
                state.loading = false;
                state.error = action.payload.error.msg;    
            }
        }
    
    })
    export const { reset, resetApiStatus, setEditData } = shoppingPartners.actions;
    export default shoppingPartners.reducer 